/* ============================================================
   froffy.js v3
   ============================================================ */

document.addEventListener('DOMContentLoaded', function () {

  /* ── Custom Cursor ── */
  if (window.matchMedia('(pointer: fine)').matches) {
    const cursor = document.getElementById('froffy-cursor');
    const ring   = document.getElementById('froffy-cursor-ring');
    if (cursor && ring) {
      let mx=0,my=0,rx=0,ry=0;
      document.addEventListener('mousemove', e => { mx=e.clientX; my=e.clientY; });
      (function tick(){
        cursor.style.left=mx+'px'; cursor.style.top=my+'px';
        rx+=(mx-rx)*.12; ry+=(my-ry)*.12;
        ring.style.left=rx+'px'; ring.style.top=ry+'px';
        requestAnimationFrame(tick);
      })();
    }
  }

  /* ── Header scroll ── */
  const hw = document.querySelector('.header-wrapper');
  if (hw) window.addEventListener('scroll', () => hw.classList.toggle('scrolled', scrollY>60), {passive:true});

  /* ── YouTube / Vimeo embed ── */
  const embedEl = document.getElementById('froffy-embed');
  if (embedEl) {
    const url = embedEl.dataset.url || '';
    let src = '';
    const yt = url.match(/(?:youtube\.com\/watch\?v=|youtu\.be\/)([\w-]+)/);
    if (yt) src=`https://www.youtube-nocookie.com/embed/${yt[1]}?autoplay=1&mute=1&loop=1&playlist=${yt[1]}&controls=0&playsinline=1&rel=0`;
    const vi = url.match(/vimeo\.com\/(\d+)/);
    if (vi) src=`https://player.vimeo.com/video/${vi[1]}?autoplay=1&muted=1&loop=1&background=1`;
    if (src) {
      const f=document.createElement('iframe');
      f.src=src; f.allow='autoplay;fullscreen'; f.setAttribute('aria-hidden','true');
      embedEl.appendChild(f);
    }
  }

  /* ── FV：イントロ動画 → クロスフェード → 順次リビール ── */
  (function () {
    const fv = document.querySelector('[data-froffy-fv]');
    if (!fv) return;
    const v = fv.querySelector('.froffy-fv__video');
    const docEl = document.documentElement;
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const isPC = window.matchMedia('(min-width:768px)').matches;

    // イントロ（動画→静止画→コピー）を見せ切るまでスクロールを止める（PC・スマホ共通）
    const INTRO_HOLD_MS = 3400;        // 静止画＋コピーが完全に出てから解除（リビール後の保持）
    let unlocked = false;
    const unlockScroll = () => { if (unlocked) return; unlocked = true; docEl.classList.remove('froffy-intro-lock'); };
    if (!reduce) { try { window.scrollTo(0, 0); } catch (e) {} docEl.classList.add('froffy-intro-lock'); }
    setTimeout(unlockScroll, 13000);   // 保険：何があっても必ず解除

    let done = false;
    const reveal = () => {
      if (done) return;
      done = true;
      fv.classList.add('is-revealed');       // CSS: 動画フェードアウト＋各要素を順次フェードアップ
      if (v) { try { v.pause(); } catch (e) {} }
      setTimeout(unlockScroll, INTRO_HOLD_MS); // コピーが立ち上がってからスクロール解除
    };

    /* ── イントロを飛ばす ──
       スクロール（ホイール）、フリック（touchmove）、スクロールキー、
       画面下の SCROLL 表示のクリックで、動画を待たずにコピーを出して解除する。
       is-skipped を付けてフェードを短くし、待たされている感じを消す。 */
    let skipArmed = true;
    const scrollHint = fv.querySelector('.froffy-fv__scroll');
    const skipIntro = () => {
      if (!skipArmed) return;
      skipArmed = false;
      fv.classList.add('is-skipped');
      reveal();
      unlockScroll();                        // 保持時間を待たずに即解除
      detachSkip();
    };
    const onKeySkip = (e) => {
      const el = e.target;                   // 文字入力中は拾わない
      if (el && (el.tagName === 'INPUT' || el.tagName === 'TEXTAREA' || el.isContentEditable)) return;
      if ([' ', 'Spacebar', 'PageDown', 'ArrowDown', 'End', 'Enter'].indexOf(e.key) >= 0) skipIntro();
    };
    function attachSkip() {
      window.addEventListener('wheel', skipIntro, { passive: true });
      window.addEventListener('touchmove', skipIntro, { passive: true });
      window.addEventListener('keydown', onKeySkip);
      if (scrollHint) {
        scrollHint.setAttribute('role', 'button');
        scrollHint.setAttribute('tabindex', '0');
        scrollHint.setAttribute('aria-label', 'イントロを飛ばす');
        scrollHint.addEventListener('click', skipIntro);
      }
    }
    function detachSkip() {
      skipArmed = false;
      window.removeEventListener('wheel', skipIntro);
      window.removeEventListener('touchmove', skipIntro);
      window.removeEventListener('keydown', onKeySkip);
      if (scrollHint) {
        scrollHint.removeEventListener('click', skipIntro);
        scrollHint.removeAttribute('role');
        scrollHint.removeAttribute('tabindex');
        scrollHint.removeAttribute('aria-label');
      }
    }

    if (reduce) { reveal(); return; }
    attachSkip();

    if (v) {
      try { v.muted = true; } catch (e) {}
      v.addEventListener('ended', function () { reveal(); detachSkip(); });
      // メタデータ取得後、動画長＋余白でリビール（ended が来ない環境の保険）
      const arm = () => { const d = v.duration; setTimeout(reveal, (isFinite(d) && d > 0) ? d * 1000 + 400 : 9000); };
      if (v.readyState >= 1) arm(); else v.addEventListener('loadedmetadata', arm, { once: true });
      // 終端付近をポーリング（一部端末で ended が発火しない対策）
      const poll = setInterval(() => {
        if (v.ended || (v.duration && v.currentTime >= v.duration - 0.06)) { clearInterval(poll); reveal(); }
      }, 400);
      setTimeout(function () { reveal(); detachSkip(); }, 11000); // ハードキャップ（黒画面で固まらせない）
      const p = v.play && v.play();
      if (p && p.catch) p.catch(() => setTimeout(reveal, 3500)); // 自動再生ブロック時
    } else {
      setTimeout(reveal, 1200);               // 動画なし → そのままリビール
    }
  })();

  /* ── FV→共感：プッシュスルー（押し込みズーム）演出 ──
     BOTANIST参照。スクロールに連れてFVへ"寄って"いき（拡大＋フェード）、前景の
     ボトルが手前へ大きくなって通り過ぎ、泡が散る。FVが光に抜けると、奥から共感が
     現れる。固定FVの transform/opacity だけを動かし、共感は通常スクロールのまま＝
     ピン留めしないのでカクつき・重なりが出ない。レール表示もここで兼ねる。 */
  (function () {
    const stage   = document.querySelector('[data-fv-stage]');
    const spacer  = document.querySelector('[data-fv-spacer]');
    const fv      = document.querySelector('[data-froffy-fv]');
    const bottle  = fv && fv.querySelector('.froffy-fv__bottle');
    const bubbles = fv ? fv.querySelectorAll('.froffy-fv__bubble') : [];
    const hasRails = !!document.querySelector('.froffy-rail');

    const clamp = (v, a, b) => Math.max(a, Math.min(b, v));
    const sm = (p, a, b) => { const t = clamp((p - a) / (b - a), 0, 1); return t * t * (3 - 2 * t); };
    const isPC = () => window.matchMedia('(min-width:768px)').matches;
    const railToggle = (on) => { if (hasRails) document.body.classList.toggle('froffy-rails-on', on); };

    // ステージが無い＝演出対象外。レールだけ単純トリガー。
    if (!stage || !spacer || !fv) {
      if (hasRails) {
        const t = () => railToggle(window.scrollY > window.innerHeight * 0.7);
        window.addEventListener('scroll', t, { passive: true });
        window.addEventListener('resize', t, { passive: true });
        t();
      }
      return;
    }

    const clearFV = () => {
      fv.style.removeProperty('transform');
      fv.style.removeProperty('opacity');
      stage.style.removeProperty('opacity');
      stage.style.removeProperty('pointer-events');
      if (bottle) bottle.style.removeProperty('transform');
      bubbles.forEach(b => b.style.removeProperty('opacity'));
    };

    let raf = 0;
    const apply = () => {
      raf = 0;

      // SP：固定演出なし（CSSで stage は relative・spacer 高0）。素の状態へ。
      if (!isPC()) {
        clearFV();
        railToggle(window.scrollY > window.innerHeight * 0.7);
        return;
      }

      const range = spacer.offsetHeight || window.innerHeight;
      const p = clamp(window.scrollY / range, 0, 1);

      // 最上部（p≈0）はイントロ・リビールに任せる（インライン干渉を外す）
      if (p <= 0.002) { clearFV(); railToggle(false); return; }

      const k = sm(p, 0, 1);
      // FV本体：カメラが寄る（拡大）＋光に抜ける（フェード）
      fv.style.transform = 'scale(' + (1 + k * 0.24).toFixed(4) + ')';
      fv.style.opacity = (1 - sm(p, 0.18, 0.74)).toFixed(3);
      // ステージ退場＋クリックを下へ通す
      stage.style.opacity = (1 - sm(p, 0.86, 1)).toFixed(3);
      stage.style.pointerEvents = p > 0.5 ? 'none' : '';
      // 前景パララックス：ボトルが手前へ大きくなって通り過ぎる
      if (bottle) bottle.style.transform = 'translateY(' + (k * 52).toFixed(1) + 'px) scale(' + (1 + k * 0.55).toFixed(3) + ')';
      // 泡は散って消える（transformはfvFloatが専有→opacityだけ触る）
      bubbles.forEach(b => { b.style.opacity = (1 - sm(p, 0.15, 0.55)).toFixed(3); });
      // レール：FVが薄くなったら現す
      railToggle(p > 0.55);
    };

    const onScroll = () => { if (!raf) raf = requestAnimationFrame(apply); };
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    apply();
  })();

  /* ── Reveal on scroll ── */
  const reveals = document.querySelectorAll('.froffy-reveal,.froffy-reveal-left,.froffy-reveal-right');
  if ('IntersectionObserver' in window) {
    const obs = new IntersectionObserver(entries => {
      entries.forEach(e => { if(e.isIntersecting){ e.target.classList.add('is-visible'); obs.unobserve(e.target); } });
    }, {threshold:.14, rootMargin:'0px 0px -36px 0px'});
    reveals.forEach(el => obs.observe(el));
  } else {
    reveals.forEach(el => el.classList.add('is-visible'));
  }

  /* ── 新セクション共通リビール（③〜⑦：data-emp-reveal → .is-in。共感②は除外） ── */
  const empReveals = Array.prototype.filter.call(
    document.querySelectorAll('[data-emp-reveal]'),
    function (el) { return !el.closest('[data-froffy-empathy]'); }
  );
  if (empReveals.length && 'IntersectionObserver' in window) {
    const empObs = new IntersectionObserver(entries => {
      entries.forEach(e => { if (e.isIntersecting) { e.target.classList.add('is-in'); empObs.unobserve(e.target); } });
    }, { threshold: 0.2, rootMargin: '0px 0px -8% 0px' });
    empReveals.forEach(el => empObs.observe(el));
  } else {
    empReveals.forEach(el => el.classList.add('is-in'));
  }

  /* ── ② 共感ゾーン：スクロール位置連動の“可逆”リビール ──
     絵が先に立ち上がり、少し間をおいて（capLag）その絵のコピーが入ってくる。
     スクロールを戻すと逆再生で消える。 */
  (function () {
    const emp = document.querySelector('[data-froffy-empathy]');
    if (!emp) return;
    const els = emp.querySelectorAll('[data-emp-reveal]');
    if (!els.length) return;

    // reduced-motion時はそのまま表示（CSS側で表示済み）
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      els.forEach(el => { el.style.setProperty('opacity', '1', 'important'); el.style.setProperty('transform', 'none', 'important'); });
      return;
    }

    const clamp = (v, a, b) => Math.max(a, Math.min(b, v));
    const easeOut = t => 1 - Math.pow(1 - t, 3);
    let raf = 0;

    const spacerEl = document.querySelector('[data-fv-spacer]');
    const apply = () => {
      raf = 0;
      const vh = window.innerHeight || document.documentElement.clientHeight;
      // プッシュスルー着地点。ここまでスクロールして「カードが出る」までは
      // 図版・コピーを一切出さない＝着地後にさらにスクロールした分で初めて出る。
      const landing = spacerEl ? spacerEl.offsetHeight : 0;
      const beforeLanding = window.scrollY < landing;
      const baseLine = vh * 0.80;   // 見出し等が出始める高さ
      const distFig  = vh * 0.50;   // 図版は“たっぷりスクロールしながら”出る（スクロール量で出す感触）
      const distCap  = vh * 0.40;   // コピーも同様にゆっくり
      const capLag   = vh * 0.40;   // コピーは図版より“ひと呼吸”遅れて出る
      els.forEach(el => {
        const isCap = el.classList.contains('froffy-emp__cap');
        const isFig = el.classList.contains('froffy-emp__fig');
        let k;
        if (isCap) {
          const row = el.closest('.froffy-emp__row, .froffy-emp__row--alt');
          const fig = row ? row.querySelector('.froffy-emp__fig') : el;
          const top = (fig || el).getBoundingClientRect().top;
          k = easeOut(clamp(((baseLine - capLag) - top) / distCap, 0, 1));
        } else {
          const top = el.getBoundingClientRect().top;
          const base = isFig ? baseLine - vh * 0.14 : baseLine;
          k = easeOut(clamp((base - top) / distFig, 0, 1));
        }
        // 図版・コピーは「カードが出た後（着地後）」に限定。着地前は完全に隠す。
        if ((isCap || isFig) && beforeLanding) k = 0;
        el.style.setProperty('transition', 'none', 'important');
        el.style.setProperty('opacity', String(k), 'important');
        el.style.setProperty('transform', 'translateY(' + (32 * (1 - k)).toFixed(1) + 'px)', 'important');
      });
    };
    const onScroll = () => { if (!raf) raf = requestAnimationFrame(apply); };
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    apply();
  })();

  /* ── ② 共感ゾーン：ピン留めステージの進行リビール ──
     カードが最上部で“停止”（CSS position:sticky）している間、スクロール進行 prog で
     1枚目の図版をボヤッ（ブラー）→くっきり、続いてコピーを出す。スクロール量で出す感触。
     sticky はブラウザネイティブ＝カクつかない。JSは opacity/filter/transform のみ。 */
  (function () {
    const pin = document.querySelector('[data-emp-pin]');
    if (!pin) return;
    const fig = pin.querySelector('[data-emp-lead-fig]');
    const cap = pin.querySelector('[data-emp-lead-cap]');
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    const clamp = (v, a, b) => Math.max(a, Math.min(b, v));
    const sm = (p, a, b) => { const t = clamp((p - a) / (b - a), 0, 1); return t * t * (3 - 2 * t); };
    const isPC = () => window.matchMedia('(min-width:768px)').matches;

    let raf = 0;
    const apply = () => {
      raf = 0;
      // SP：CSSで表示済み。インラインを消して素に。
      if (!isPC()) {
        if (fig) { fig.style.removeProperty('opacity'); fig.style.removeProperty('filter'); fig.style.removeProperty('transform'); }
        if (cap) { cap.style.removeProperty('opacity'); cap.style.removeProperty('transform'); }
        return;
      }
      const vh = window.innerHeight || document.documentElement.clientHeight;
      const span = pin.offsetHeight - vh;             // sticky が効く距離
      const prog = span > 0 ? clamp(-pin.getBoundingClientRect().top / span, 0, 1) : 0;

      // prog 0〜0.10：見出しだけ（“停止”の間）。以降で図版がボヤッ→くっきり。
      const fa = sm(prog, 0.10, 0.52);
      if (fig) {
        fig.style.opacity = fa.toFixed(3);
        fig.style.filter = 'blur(' + ((1 - fa) * 18).toFixed(2) + 'px)';
        fig.style.transform = 'scale(' + (1 + (1 - fa) * 0.05).toFixed(4) + ')';
      }
      // コピーは図版のあと“ひと呼吸”遅れて
      const fc = sm(prog, 0.46, 0.82);
      if (cap) {
        cap.style.opacity = fc.toFixed(3);
        cap.style.transform = 'translateY(' + ((1 - fc) * 26).toFixed(1) + 'px)';
      }
    };
    const onScroll = () => { if (!raf) raf = requestAnimationFrame(apply); };
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    apply();
  })();

  /* ── FAQ Accordion ── */
  document.querySelectorAll('.froffy-faq__question').forEach(btn => {
    btn.addEventListener('click', function() {
      const item=this.closest('.froffy-faq__item'), isOpen=item.classList.contains('is-open');
      document.querySelectorAll('.froffy-faq__item.is-open').forEach(i=>i.classList.remove('is-open'));
      if (!isOpen) item.classList.add('is-open');
    });
  });

  /* ── Purchase card toggle ── */
  document.querySelectorAll('.froffy-purchase__card').forEach(card => {
    card.addEventListener('click', function() {
      document.querySelectorAll('.froffy-purchase__card').forEach(c=>c.classList.remove('is-selected'));
      this.classList.add('is-selected');
      const pi=document.querySelector('input[name="selling_plan"]');
      if (pi) pi.value=this.dataset.sellingPlan||'';
    });
  });

  /* ── Qty selector ── */
  document.querySelectorAll('.froffy-purchase__qty-btn').forEach(btn => {
    btn.addEventListener('click', function() {
      const wrap=this.closest('.froffy-purchase__qty');
      const numEl=wrap.querySelector('.froffy-purchase__qty-num');
      let qty=parseInt(numEl.textContent)||1;
      if(this.dataset.action==='increase') qty=Math.min(qty+1,10);
      if(this.dataset.action==='decrease') qty=Math.max(qty-1,1);
      numEl.textContent=qty;
      const inp=document.querySelector('input[name="quantity"]');
      if(inp) inp.value=qty;
    });
  });

  /* ════════════════════════════════════════════
     共感ゾーン v4：スクロールリビール（暖かい演出）
     ════════════════════════════════════════════ */
  const scrollItems = document.querySelectorAll('.froffy-empathy__scroll-item');
  if (scrollItems.length && 'IntersectionObserver' in window) {
    const empObs = new IntersectionObserver((entries) => {
      entries.forEach(e => {
        if (e.isIntersecting) {
          e.target.classList.add('is-visible');
          // 一度表示したら監視解除（再スクロールで消えない）
          empObs.unobserve(e.target);
        }
      });
    }, {
      threshold: 0.35,          // 要素が35%見えたら発火
      rootMargin: '0px 0px -80px 0px'  // 少し手前で発火
    });
    scrollItems.forEach(el => empObs.observe(el));
  } else {
    scrollItems.forEach(el => el.classList.add('is-visible'));
  }

  /* ════════════════════════════════════════════
     フォントサイズ CSS変数注入
     各セクションに data-* 属性でサイズ値を渡す
     ════════════════════════════════════════════ */
  function injectFontVars(selector, varMap) {
    const el = document.querySelector(selector);
    if (!el) return;
    Object.entries(varMap).forEach(([attr, cssVar]) => {
      const val = el.dataset[attr];
      if (val) el.style.setProperty(cssVar, val + 'rem');
    });
  }

  injectFontVars('.froffy-empathy', {
    quoteSize: '--empathy-quote-size',
    bodySize:  '--empathy-body-size',
  });
  injectFontVars('.froffy-scene', {
    headingSize: '--scene-heading-size',
    bodySize:    '--scene-body-size',
  });
  injectFontVars('.froffy-about', {
    headingSize:   '--about-heading-size',
    bodySize:      '--about-body-size',
    highlightSize: '--about-highlight-size',
  });
  injectFontVars('.froffy-difference', {
    textSize: '--diff-text-size',
    noteSize: '--diff-note-size',
  });
  injectFontVars('.froffy-features', {
    titleSize: '--feat-title-size',
    descSize:  '--feat-desc-size',
  });
  injectFontVars('.froffy-faq', {
    qSize: '--faq-q-size',
    aSize: '--faq-a-size',
  });
  injectFontVars('.froffy-purchase', {
    headingSize: '--purchase-heading-size',
    subSize:     '--purchase-sub-size',
  });

});

/* ── ④ 4つの価値：スクロール連動フォーカス（中央の行が主役化） ──
   画面中央の細いバンドに入った行へ .is-focus を付ける（時間ベースでなく位置ベース）。
   前後は CSS で静かに沈む。JS/IO 未対応・reduced-motion 時は全行を主役表示（沈ませない）。 */
(function () {
  function init() {
    var sec = document.querySelector('[data-froffy-values]');
    if (!sec) return;
    var rows = sec.querySelectorAll('.froffy-val__row');
    if (!rows.length) return;

    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (!('IntersectionObserver' in window) || reduce) {
      Array.prototype.forEach.call(rows, function (r) { r.classList.add('is-focus'); });
      return;
    }

    sec.classList.add('is-foci-ready');
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        e.target.classList.toggle('is-focus', e.isIntersecting);
      });
    }, { rootMargin: '-40% 0px -40% 0px', threshold: 0 });
    Array.prototype.forEach.call(rows, function (r) { obs.observe(r); });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else { init(); }
})();

/* ── 香り：TOP → MIDDLE → LAST の切り替え ──
   フリック／時間メーターのクリック／矢印キーで進む。
   表示の切り替えは CSS の opacity が担うので、ここでは is-active / is-filled の
   付け外しだけを行う（要素の出し入れをしないため高さが動かない）。 */
(function () {
  function setup(sec) {
    if (sec.dataset.sjReady) return;
    sec.dataset.sjReady = '1';

    var stage = sec.querySelector('[data-sj-stage]');
    var track = sec.querySelector('[data-sj-track]');
    if (!stage || !track) return;

    var steps = sec.querySelectorAll('[data-sj-step]');
    var bars  = sec.querySelectorAll('.froffy-frg__bar');
    var times = sec.querySelectorAll('.froffy-frg__time');
    var LAST  = 2;
    var i = 0;
    var dragX = null;
    var EASE = 'transform .55s cubic-bezier(.22,.61,.36,1)';

    function render() {
      Array.prototype.forEach.call(steps, function (el) {
        el.classList.toggle('is-active', Number(el.dataset.sjStep) === i);
      });
      Array.prototype.forEach.call(bars, function (el, n) {
        el.classList.toggle('is-filled', n <= i);
      });
      Array.prototype.forEach.call(times, function (el, n) {
        el.classList.toggle('is-active', n === i);
      });
    }

    function go(n) {
      i = Math.max(0, Math.min(LAST, n));
      track.style.transition = EASE;
      track.style.transform = 'translateX(0px)';
      render();
    }

    Array.prototype.forEach.call(sec.querySelectorAll('[data-sj-go]'), function (btn) {
      btn.addEventListener('click', function () { go(Number(btn.dataset.sjGo)); });
    });

    stage.addEventListener('pointerdown', function (e) {
      dragX = e.clientX;
      try { stage.setPointerCapture(e.pointerId); } catch (err) {}
      track.style.transition = 'none';
    });
    stage.addEventListener('pointermove', function (e) {
      if (dragX === null) return;
      /* 指より控えめに追従させる（大きく動かすと騒がしくなる） */
      track.style.transform = 'translateX(' + (e.clientX - dragX) * 0.3 + 'px)';
    });
    function release(e) {
      if (dragX === null) return;
      var dx = e.clientX - dragX;
      dragX = null;
      go(i + (dx < -50 ? 1 : dx > 50 ? -1 : 0));
    }
    stage.addEventListener('pointerup', release);
    stage.addEventListener('pointercancel', release);

    /* 矢印キーは、このセクションが画面内にあるときだけ拾う */
    if ('IntersectionObserver' in window) {
      var visible = false;
      new IntersectionObserver(function (es) {
        visible = es[0].isIntersecting;
      }, { threshold: 0.3 }).observe(sec);
      window.addEventListener('keydown', function (e) {
        if (!visible) return;
        if (e.key === 'ArrowRight') go(i + 1);
        if (e.key === 'ArrowLeft')  go(i - 1);
      });
    }

    render();
  }

  function init() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-froffy-scent]'), setup);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else { init(); }
  /* テーマエディタでセクションを編集し直したときに再初期化する */
  document.addEventListener('shopify:section:load', init);
})();

/* ── PC固定サイドレール：フッターに差しかかったら引っ込める ──
   レールは position:fixed のため、そのままだとフッターの上に重なってしまう。
   フッターが画面に入ってきたら body に .froffy-rails-off を付けて退場させる。 */
(function () {
  function initRailsOff() {
    var footer = document.querySelector('[data-froffy-footer]');
    if (!footer) return;
    if (!('IntersectionObserver' in window)) return;

    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        document.body.classList.toggle('froffy-rails-off', e.isIntersecting);
      });
    }, {
      /* フッターの手前で消え始めるよう、下側に少し余裕をみる */
      rootMargin: '0px 0px -40px 0px',
      threshold: 0
    });
    obs.observe(footer);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initRailsOff);
  } else { initRailsOff(); }
  document.addEventListener('shopify:section:load', initRailsOff);
})();

/* ── オファー帯＋ヘッダー：FVを見せ切ってから画面上部へ出す ──
   FVのあるページ（body.froffy-has-fv）だけで働く。
   FVの固定演出と同じタイミングで body に .froffy-head-on を付け外しする。
   その他のページでは何もしない（CSSで通常表示のまま）。 */
(function () {
  function initHeadReveal() {
    if (!document.body.classList.contains('froffy-has-fv')) return;

    var fv = document.querySelector('[data-froffy-fv]');
    if (!fv) {
      /* トップでもFVを置いていない構成なら、最初から出しておく */
      document.body.classList.add('froffy-head-on');
      return;
    }

    var spacer = document.querySelector('[data-fv-spacer]');
    var isPC = function () { return window.matchMedia('(min-width:768px)').matches; };
    var raf = 0;

    var apply = function () {
      raf = 0;
      var show;
      if (isPC() && spacer && spacer.offsetHeight > 0) {
        /* PC：FVが光に溶けていく尺の後半で出す（レール出現と同じ頃合い） */
        var range = spacer.offsetHeight || window.innerHeight;
        show = (window.scrollY / range) > 0.55;
      } else {
        /* SP：FVの高さの7割を過ぎたら出す */
        show = window.scrollY > window.innerHeight * 0.7;
      }
      document.body.classList.toggle('froffy-head-on', show);
    };

    var onScroll = function () { if (!raf) raf = requestAnimationFrame(apply); };
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    apply();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initHeadReveal);
  } else { initHeadReveal(); }
  document.addEventListener('shopify:section:load', initHeadReveal);
})();

/* ── ⑦ オファー：画像カードのスワイプ・インジケーター（スマホ） ──
   カード枚数ぶんの点を作り、横スクロール位置に合わせて現在地を示す。 */
(function () {
  function initPlanDots() {
    var wraps = document.querySelectorAll('[data-plan-dots]');
    Array.prototype.forEach.call(wraps, function (dots) {
      var plans = dots.closest('.froffy-offer__plans');
      if (!plans) return;
      var grid = plans.querySelector('.froffy-offer__plan-grid');
      if (!grid) return;
      var cards = grid.querySelectorAll('.froffy-offer__plan--image');
      var nav = plans.querySelector('[data-plan-nav]');
      if (cards.length < 2) {
        dots.innerHTML = '';
        if (nav) nav.hidden = true;   /* 送る先がないので矢印ごと隠す */
        return;
      }
      if (nav) nav.hidden = false;

      /* 二重生成を防ぐ */
      if (dots.getAttribute('data-ready') === String(cards.length)) return;
      dots.innerHTML = '';
      dots.setAttribute('data-ready', String(cards.length));
      for (var i = 0; i < cards.length; i++) {
        var d = document.createElement('span');
        if (i === 0) d.className = 'is-on';
        dots.appendChild(d);
      }

      /* ドットを押して移動できるようにする（PCでは主な操作手段） */
      Array.prototype.forEach.call(dots.children, function (d, i) {
        d.setAttribute('role', 'button');
        d.setAttribute('tabindex', '0');
        d.setAttribute('aria-label', (i + 1) + '枚目へ');
        var go = function () { scrollToCard(i); };
        d.addEventListener('click', go);
        d.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); go(); }
        });
      });
      dots.removeAttribute('aria-hidden');

      function scrollToCard(i) {
        var c = cards[i];
        if (!c) return;
        grid.scrollTo({ left: c.offsetLeft - (grid.clientWidth - c.offsetWidth) / 2, behavior: 'smooth' });
      }
      /* 左右の矢印。端まで行ったらループする（ドットの自動送りと同じ挙動）。 */
      if (nav) {
        var prevBtn = nav.querySelector('[data-plan-prev]');
        var nextBtn = nav.querySelector('[data-plan-next]');
        var step = function (dir) {
          var i = currentIndex() + dir;
          if (i < 0) i = cards.length - 1;
          if (i >= cards.length) i = 0;
          scrollToCard(i);
        };
        if (prevBtn) prevBtn.addEventListener('click', function () { step(-1); });
        if (nextBtn) nextBtn.addEventListener('click', function () { step(1); });
      }

      function currentIndex() {
        var center = grid.scrollLeft + grid.clientWidth / 2, best = 0, bg = Infinity;
        for (var i = 0; i < cards.length; i++) {
          var g = Math.abs(cards[i].offsetLeft + cards[i].offsetWidth / 2 - center);
          if (g < bg) { bg = g; best = i; }
        }
        return best;
      }

      /* 3秒ごとに自動で送る。最後まで行ったら先頭へ戻る（ループ）。
         操作中・画面外・「動きを減らす」設定のときは止める。 */
      var AUTOPLAY_MS = 3000;
      var timer = 0;
      var paused = false;
      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      function advance() {
        if (paused) return;
        var next = currentIndex() + 1;
        scrollToCard(next >= cards.length ? 0 : next);
      }
      function start() {
        if (reduce || timer) return;
        timer = setInterval(advance, AUTOPLAY_MS);
      }
      function stop() {
        if (!timer) return;
        clearInterval(timer);
        timer = 0;
      }

      /* 触っている間・ドットを操作した直後は止める */
      ['pointerdown', 'touchstart', 'mouseenter', 'focusin'].forEach(function (ev) {
        grid.addEventListener(ev, function () { paused = true; stop(); }, { passive: true });
      });
      ['mouseleave', 'focusout'].forEach(function (ev) {
        grid.addEventListener(ev, function () { paused = false; start(); });
      });
      dots.addEventListener('click', function () {
        paused = true; stop();
        setTimeout(function () { paused = false; start(); }, AUTOPLAY_MS * 2);
      });

      /* 画面に入っている間だけ動かす（見えていない所で回さない） */
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          entries.forEach(function (e) { e.isIntersecting ? start() : stop(); });
        }, { threshold: 0.3 }).observe(grid);
      } else {
        start();
      }
      document.addEventListener('visibilitychange', function () {
        document.hidden ? stop() : start();
      });

      var raf = 0;
      var sync = function () {

        raf = 0;
        var center = grid.scrollLeft + grid.clientWidth / 2;
        var best = 0, bestGap = Infinity;
        for (var i = 0; i < cards.length; i++) {
          var c = cards[i];
          var mid = c.offsetLeft + c.offsetWidth / 2;
          var gap = Math.abs(mid - center);
          if (gap < bestGap) { bestGap = gap; best = i; }
        }
        var ds = dots.children;
        for (var j = 0; j < ds.length; j++) {
          ds[j].className = (j === best) ? 'is-on' : '';
        }
      };
      grid.addEventListener('scroll', function () {
        if (!raf) raf = requestAnimationFrame(sync);
      }, { passive: true });
      window.addEventListener('resize', function () {
        if (!raf) raf = requestAnimationFrame(sync);
      }, { passive: true });
      sync();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPlanDots);
  } else { initPlanDots(); }
  document.addEventListener('shopify:section:load', initPlanDots);
})();

/* ── 商品ページ：「購入する」ボタン ──
   Shop Pay のボタン（文言・色を変えられない）の代わりに置いた自前ボタン。
   押されたらカートに入れ、そのままチェックアウトへ進む。 */
(function () {
  function initBuyNow() {
    var btns = document.querySelectorAll('[data-froffy-buynow]');
    Array.prototype.forEach.call(btns, function (btn) {
      if (btn.getAttribute('data-ready') === '1') return;
      btn.setAttribute('data-ready', '1');
      btn.addEventListener('click', function (e) {
        var form = btn.closest('form');
        if (!form) return;
        e.preventDefault();
        if (btn.disabled) return;
        btn.classList.add('is-loading');

        var data = new FormData(form);
        fetch('/cart/add.js', { method: 'POST', body: data, headers: { Accept: 'application/json' } })
          .then(function (r) { return r.ok ? r.json() : Promise.reject(r); })
          .then(function () { window.location.href = '/checkout'; })
          .catch(function () {
            /* 失敗したら通常のカート投入に任せる */
            btn.classList.remove('is-loading');
            form.submit();
          });
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initBuyNow);
  } else { initBuyNow(); }
  document.addEventListener('shopify:section:load', initBuyNow);
})();

/* ── 購入プラン選択（単発／定期便）────────────────────────────
   カードのラジオと周期ボタンから、購入フォームの selling_plan を組み立てる。
   プランのデータは Liquid が書き出したものを読むだけなので、
   アプリ側で周期や割引を変えてもこのコードは変更不要。            */
(function () {
  var root = document.querySelector('[data-froffy-plans]');
  if (!root) return;

  var cards  = root.querySelectorAll('[data-plan-card]');
  var hidden = root.querySelector('[data-plan-input]');
  if (!hidden) return;

  // Subscriptions アプリは、ウィジェットをCSSで隠してもJSが動き続け、
  // 購入フォームに自前の selling_plan（空＝単発）を注入してくる。
  // 同名の欄が複数あると後ろの空の値が勝つため、すべてを同じ値に揃える。
  function syncSellingPlan(value) {
    document.querySelectorAll('input[name="selling_plan"]').forEach(function (el) {
      if (el.type === 'hidden') { el.value = value; }
    });
  }

  function currentPlanValue() {
    var on = root.querySelector('[data-plan-card].is-active [data-plan-radio]');
    return on ? on.value : '';
  }

  function activate(card) {
    cards.forEach(function (c) { c.classList.toggle('is-active', c === card); });
    var radio = card.querySelector('[data-plan-radio]');
    if (radio) radio.checked = true;
    syncSellingPlan(radio ? radio.value : '');
    // かつてここで body に froffy-sub-selected を付け、定期便選択中は初回割引の訴求を
    // 隠していた。Order Bonus が appliesOnSubscription:true になり定期便にも適用される
    // ようになったため撤去（2026-09-29 実測で確認）。訴求は自前のプランカードに一本化。
  }

  // 送信の直前にもう一度揃える。Dawn のフォーム処理より先に走らせたいので capture 段階で拾う。
  document.addEventListener('submit', function () { syncSellingPlan(currentPlanValue()); }, true);
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-froffy-buynow], .product-form__submit')) {
      syncSellingPlan(currentPlanValue());
    }
  }, true);

  cards.forEach(function (card) {
    card.addEventListener('click', function (e) {
      // 周期ボタンは下の専用ハンドラで処理する（カード選択と二重に動かさない）
      if (e.target.closest('[data-plan-cycle]')) return;
      activate(card);
    });
  });

  // 周期を切り替える：そのカードを選択状態にし、価格と selling_plan を差し替える
  root.querySelectorAll('[data-plan-cycle]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var card = btn.closest('[data-plan-card]');
      if (!card) return;

      card.querySelectorAll('[data-plan-cycle]').forEach(function (b) {
        b.classList.toggle('is-on', b === btn);
      });

      var radio = card.querySelector('[data-plan-radio]');
      if (radio) radio.value = btn.getAttribute('data-plan-cycle');

      var amount = card.querySelector('[data-plan-amount]');
      var price  = btn.getAttribute('data-plan-price');
      if (amount && price) amount.textContent = price;

      // 初回価格を併記している場合は、そちらも周期に合わせて差し替える
      var firstAmount = card.querySelector('[data-plan-first-amount]');
      var firstPrice  = btn.getAttribute('data-plan-first');
      if (firstAmount && firstPrice) firstAmount.textContent = firstPrice;

      // 値引き率のラベルも周期に合わせて差し替える（周期ごとに割引が違う場合に備える）
      var badge = card.querySelector('[data-plan-badge]');
      var off   = parseInt(btn.getAttribute('data-plan-off'), 10);
      if (badge) {
        if (off > 0) { badge.textContent = off + '%OFF'; badge.hidden = false; }
        else { badge.hidden = true; }
      }

      activate(card);
    });
  });
})();

/* ── PCレール「Top」：ページ最上部へ戻す ──────────────────
   FV（.froffy-fv-stage）は position:fixed で画面に固定されているため、
   #froffy-fv へのアンカーでは何も起きない。ここで最上部へ送る。
   「動きを減らす」設定のときは即座に移動する（§3.5）。 */
(function () {
  document.addEventListener('click', function (e) {
    var a = e.target.closest ? e.target.closest('[data-rail-top]') : null;
    if (!a) return;
    e.preventDefault();
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    window.scrollTo({ top: 0, behavior: reduce ? 'auto' : 'smooth' });
  });
})();
